<template>
  <v-container fluid class="futuristic-panel">
    <v-card flat class="futuristic-card">
      <v-card-title class="panel-heading"><h4 class="earth-color">ADD CURRENCY</h4></v-card-title>
      <hr class="futuristic-divider" />
      <v-container>
        <v-form @submit.prevent="postCurrency()">
          <v-text-field
            label="Name"
            v-model="currency.name"
            :rules="requiredRules"
            required
            class="futuristic-input"
            outlined
          ></v-text-field>
          <v-text-field
            label="Sign"
            v-model="currency.sign"
            :rules="requiredRules"
            required
            class="futuristic-input"
            outlined
          ></v-text-field>
          <v-textarea
            label="Description"
            v-model="currency.description"
            :rules="requiredRules"
            required
            class="futuristic-input"
            outlined
          ></v-textarea>
          <v-btn
            :depressed="true"
            color="primary"
            block
            type="submit"
            class="futuristic-btn"
          >Add Currency</v-btn>
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "AddCurrency",
  data() {
    return {
      currency: {
        name: "",
        sign: "",
        description: "",
        session_id: localStorage.getItem("lkjhgfdsa")
      },
      requiredRules: [v => !!v || "This field is required"]
    };
  },
  methods: {
    postCurrency: function() {
      this.$store.dispatch("post_currency", this.currency);
    }
  }
};
</script>

<style scoped>
/* Futuristic Panel */
.futuristic-panel {
  background: #f5f7fa;
  padding: 16px;
  border-radius: 8px;
}

/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.panel-heading {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
}

.earth-color {
  color: #4caf50;
  font-weight: 600;
  margin: 0;
}

.futuristic-divider {
  border: 0;
  height: 1px;
  background: linear-gradient(to right, rgba(76, 175, 80, 0.2), rgba(76, 175, 80, 0.8), rgba(76, 175, 80, 0.2));
  margin: 8px 0 16px;
}

/* Input Styling */
.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  margin-bottom: 16px;
}

.futuristic-input >>> .v-text-field__slot input,
.futuristic-input >>> .v-text-field__slot textarea {
  color: #333;
}

/* Button Styling */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 4px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .futuristic-panel {
    padding: 12px;
  }

  .panel-heading {
    padding: 12px;
  }

  .futuristic-btn {
    margin: 2px;
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }

  .panel-heading {
    border-radius: 6px 6px 0 0;
  }

  .futuristic-input >>> .v-input__slot {
    border-radius: 6px;
  }

  .futuristic-btn {
    border-radius: 6px;
    width: 100%;
    margin: 4px 0;
  }
}
</style>